'use strict';

const template   = require('commons/templates/Main.ejs');
const navMenuTpl = require('../templates/NavMenu.ejs');
const tooltip    = require('helpers/tooltip');

module.exports = Backbone.View.extend({
    el:      '.content',
    childEl: '#main-area',

    initialize: function() {
        this.render();
    },

    render: function() {
        this.$el.html(template({
            navMenu:    navMenuTpl({userName: app.user.get('name')}),
            headerMenu: null,
            version:    app.version,
            whitelabel: false,
            logoUrl: ''
        }));

        $('body').removeClass('gray-bg');

        tooltip.initBody();
    },

    setActiveLink: function(route) {
        this.$el.find('#side-menu li').removeClass('active');

        this.$el.find('#side-menu a[href="#' + route + '"]').parent()
            .addClass('active');
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/Main.js